



















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSPagination, { PaginationModel } from './AMSPagination.vue';
import AMSTable from './AMSTable.vue';
import request from '@/utils/request';
import { getModuleName } from '@/utils/utils';
import { QueryStore } from '../store/modules/query';
import Utils from '../utils/utils';
@Component({
  components: {
    'ams-pagination': AMSPagination,
    'ams-table': AMSTable
  }
})
export default class AMSformTable extends Vue {
  /**工具栏的全选 */
  operateAll: boolean = false;
  /**工具栏的全选 */
  indeterminate: boolean = false;
  searchloading: boolean = false;
  public $refs!: {
    amstable: HTMLElement;
  };

  pagination: PaginationModel = {
    sortBy: '',
    descending: false,
    page: 0,
    rowsPerPage: 10, // -1 for All",
    totalItems: 0,
    pageSizes: [10, 20, 30, 40]
  };
  list: any = [];
  otherData: object = {};
  @Prop() api?: string;
  @Prop() form?: object;
  @Prop() headers?: Array<object>;
  @Prop() beforeQuery?: Function;
  @Prop() isSelectAll?: boolean;
  @Prop({ default: null }) rowClickData: any;
  innerHeader?: Array<object> = this.headers;
  @Prop({
    type: Array,
    default: () => {
      return new Array();
    }
  })
  value!: any[] | undefined;

  created() {
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_page`) as string)) {
      this.pagination = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_page`) as string);
    }
  }
  mounted() {
    this.query();
  }
  checkedAll() {
    (this.$refs.amstable as HTMLFormElement).toggleAll();
    this.operateAll = !this.operateAll;
  }
  clear() {
    this.$emit('clearForm');
  }
  clearSelected() {
    (this.$refs.amstable as HTMLFormElement).clearSeleted();
  }
  query(isHandle = false) {
    if (isHandle) {
      if (this.beforeQuery) {
        this.beforeQuery();
      }
      this.pagination.page = 0;
      localStorage.setItem(`${getModuleName(this.$route.name as string)}_page`, JSON.stringify(this.pagination));
      // this.onPageChange(0);
    }

    //vuex
    // QueryStore.Set_query({ [getModuleName(this.$route.name as string)]: null });
    // QueryStore.Set_query({ [getModuleName(this.$route.name as string)]: { form: this.form } });

    let param = Object.assign({}, this.form, {
      skipCount: this.pagination.page * this.pagination.rowsPerPage,
      maxResultCount: this.pagination.rowsPerPage,
      sorting: this.pagination.sortBy
    });
    if (Object.keys(param).length > 0 && Object.keys(param).indexOf('brandId') != -1) {
      if ((param as any).brandId.id) {
        (param as any).brandId = (param as any).brandId.id;
      }
    }
    if (this.$route.name !== 'stockDetail') {
      localStorage.setItem(`${getModuleName(this.$route.name as string)}_page`, '');
      localStorage.setItem(`${getModuleName(this.$route.name as string)}_search`, '');
      localStorage.setItem(`${getModuleName(this.$route.name as string)}_search`, JSON.stringify(this.form));
      localStorage.setItem(`${getModuleName(this.$route.name as string)}_page`, JSON.stringify(this.pagination));
    }

    this.searchloading = true;
    request.get(this.api!, param).then((data: any) => {
      this.searchloading = false;
      if (this.$route.name === 'orderList') {
        this.list = data.orderList.items;
      } else if (this.$route.name === 'shipmentManagement') {
        this.list = data.shipList.items;
      } else if (this.$route.name!.indexOf('capitalAccount') >= 0) {
        //资金账户
        this.innerHeader = [];
        data.headers.forEach((header: any, i: any) => {
          this.innerHeader!.push({
            text: header.text,
            value: header.fieldName,
            sortable: header.isSort,
            isCurrency: i === 2 || i === 3 || i === 4 || i === 5 || i === 6 || i === 7 || i === 8,
            align: i !== 0 && i !== 1 ? 'right' : 'left'
          });
        });
        if (this.innerHeader) {
          let items: any[] = [];
          data.data.items.forEach((item: any) => {
            var newObject: { [key: string]: any } = {};
            this.innerHeader!.forEach((header: any, idx) => {
              newObject[header.value] = item.data[idx];
            });
            newObject['id'] = item.id;
            newObject['isActive'] = item.isActive;
            items.push(newObject);
          });
          this.list = items;
        }
      } else {
        this.list = data.items;
      }
      if (this.$route.name === 'orderList') {
        this.pagination.totalItems = data.orderList.totalCount;
      } else if (this.$route.name!.indexOf('capitalAccount') >= 0) {
        this.pagination.totalItems = data.data.totalCount;
      } else if (this.$route.name!.indexOf('shipmentManagement') >= 0) {
        this.pagination.totalItems = data.shipList.totalCount;
      } else if (this.$route.name!.indexOf('commision_list') >= 0 || this.$route.name!.indexOf('good_report_list') >= 0 || this.$route.name!.indexOf('stock_report') >= 0) {
        this.pagination.totalItems = data.data.result.dataRows.totalCount;
      } else {
        this.pagination.totalItems = data.totalCount;
      }
      this.otherData = {
        customerOrderCount: data.customerOrderCount,
        materialOrderCount: data.materialOrderCount,
        totalFreezeAmount: data.totalFreezeAmount,
        totalBalance: data.totalBalance,
        finishedCount: data.finishedCount,
        orderCount: data.orderCount,
        partialDeliveryCount: data.partialDeliveryCount,
        pendingConfirmCount: data.pendingConfirmCount,
        pendingCount: data.pendingCount,
        totalCount: data.totalCount,
        items: data.data && data.data.result
      };
    });
  }
  onPageChange(page: number) {
    this.pagination.page = page;
    this.query();
  }
  onPageSizeChange(size: number) {
    this.pagination.rowsPerPage = size;
    this.query();
  }
  btnClick(btn: any, index: number, key: string) {
    this.$emit('btnClick', btn, index, key);
  }
  selectedAll(value: Array<any>) {
    if (value.length > 0 && value.length == this.list.length) {
      this.indeterminate = false;
      this.operateAll = true;
    } else if (value.length > 0 && value.length < this.list.length) {
      this.operateAll = false;
      this.indeterminate = true;
    } else if (value.length == 0) {
      this.operateAll = false;
      this.indeterminate = false;
    }
    this.$emit('selectedAll', value);
  }
  sortByItem(value: string) {
    if (value) {
      this.pagination.sortBy = value;
      this.query();
    }
  }
  @Watch('otherData')
  changeOtherData(val: any) {
    this.otherData = val;
    this.$emit('getOtherData', this.otherData);
  }

  @Watch('value')
  changeValueData(val: any) {
    if (val && val.length > 0) {
      this.list = val;
    }
  }
}
